import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// After index.css and before any theme sheet: themes must be able to
// override these cross-theme defaults on equal specificity.
import "./styles/polish.css";
import App from "./App";
import { ThemeProvider } from "./themes/ThemeProvider";
import reportWebVitals from "./reportWebVitals";
// import { initSDK } from "@hyperdx/node-opentelemetry";
// import { HfInference } from "@huggingface/inference";
import { Analytics } from "@vercel/analytics/react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// const hf = new HfInference(process.env.HUGGINGFACE_API);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
    <Analytics />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// initSDK({ consoleCapture: true, additionalInstrumentations: [] });
